import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from '@roomex/rx-components';
import { TermsAndConditions } from '@rx-applications/clientsite/shared/utils';
import { CleanupHtmlPipe } from './../../pipes/cleanup-html/cleanup-html.pipe';
import { SafeHtmlPipe } from './../../pipes/safe-html/safe-html.pipe';


@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalContentComponent, CleanupHtmlPipe, SafeHtmlPipe]
})
export class TermsAndConditionsComponent implements OnInit {
  @Input() title!: string;
  @Input() reservationTerms!: TermsAndConditions;
  @Input({required: true}) termsAndConditionsHtml!: string;
  @ViewChild('nosanitize', { static: true }) private nosanitize!: ElementRef;  

  constructor(
    public activeModal: NgbActiveModal,
    private renderer: Renderer2,
  ) {}
  ngOnInit(): void {
    this.nosanitize.nativeElement.innerHTML = this.termsAndConditionsHtml;
    this.renderer.listen(this.nosanitize.nativeElement, 'click', (event: Event) => {
      if (event && event.target && (<HTMLElement>event.target).tagName !== 'A') {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      const element = document.getElementsByName((<HTMLAnchorElement>event.target).hash.replace('#', '')).item(0);
      if (element) {
        element.scrollIntoView();
      }
    });
  }

  get reservationTermsFormatted() {
    return [...this.reservationTerms.cancelPenalties, '<br />', ...this.reservationTerms.contractComments].join('');
  }
}
